$(document).ready(() => {
  const modal = $('#capsule-calculator-BaS')
  if (!modal.length) return

  $('select[data-calculator-BaS-selectize]').selectize({
    delimiter: ',',
    persist: false,
    create: false,
    onChange: function (value) {
      if(!value) return

      updateBaSCalculatorContent();
    },
    onDropdownOpen: function() {
      this.$control_input
        .focus()
        .blur()
        .prop('readonly', true)
        .on('mousedown', function() {
          $(this).prop('readonly', false);
        });
    },
  });

  
  function updateBaSCalculatorContent() {
    const productSelectMobile = $('select[data-type="calculator-product-content"]').find('option:selected').val();
    
    Object.keys(calculatorSizes).forEach((size) => {
      const productMobile = calculatorData.find((product) => product.product_type == productSelectMobile) || calculatorData[0]
      const sizeItem = $(`.capsule-calculator-BaS-right .size-item[data-size="${size}"]`)
      sizeItem.find('.days').text(productMobile[size]?.days)
      sizeItem.find('.uses').text(productMobile[size]?.uses)
    })
  }
  updateBaSCalculatorContent()
})